const nhMetricColumnData = [
  {
    Header: 'Transaction Type',
    accessor: 'transactionType'
  },
  {
    Header: 'Direction',
    accessor: 'direction',
    Cell: ({ value }) => {
      return value ? value.toUpperCase() : '-';
    }
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ value }) => {
      const statusColors = {
        SUCCESS: '#21a921',
        PENDING: '#ffa500',
        FAILED: '#c41e1e'
      };
      return (
        <span style={{ color: statusColors[value] || '#fff', fontWeight: '600' }}>
          {value ? value.toUpperCase() : '-'}
        </span>
      );
    }
  },
  {
    Header: 'Amount (BTC)',
    accessor: 'amount',
    Cell: ({ value }) => {
      return value ? `${Number(value).toFixed(8)} BTC` : '-';
    }
  },
  {
    Header: 'Coin Amount',
    accessor: 'coinAmount',
    Cell: ({ value, row }) => {
      if (!value) return '-';
      const coin = row.original?.coin;
      const coinSymbol = coin ? coin.toUpperCase() : '';
      return `${Number(value).toFixed(8)}${coinSymbol ? ` ${coinSymbol}` : ''}`;
    }
  },
  {
    Header: 'Amount (USD)',
    accessor: 'baseAmount',
    Cell: ({ value }) => {
      return value ? `$${Number(value).toFixed(2)}` : '-';
    }
  },
  {
    Header: 'Currency',
    accessor: 'currency',
    Cell: ({ value }) => {
      return value ? value.toUpperCase() : '-';
    }
  },
  {
    Header: 'Base Currency',
    accessor: 'baseCurrency',
    Cell: ({ value }) => {
      return value ? value.toUpperCase() : '-';
    }
  },
  {
    Header: 'Engine ID',
    accessor: 'engineId',
    Cell: ({ value }) => {
      return value || '-';
    }
  },
  {
    Header: 'Room ID',
    accessor: 'roomId',
    Cell: ({ value }) => {
      return value || '-';
    }
  },
  {
    Header: 'Bet Limit ID',
    accessor: 'betLimitId',
    Cell: ({ value }) => {
      return value || '-';
    }
  },
  {
    Header: 'Coin',
    accessor: 'coin',
    Cell: ({ value }) => {
      return value ? value.toUpperCase() : '-';
    }
  },
  {
    Header: 'Error Message',
    accessor: 'errorMessage',
    Cell: ({ value }) => {
      return value || '-';
    }
  },
  {
    Header: 'Created At',
    accessor: 'createdAt'
  },
  {
    Header: 'Updated At',
    accessor: 'updatedAt'
  }
];

export default nhMetricColumnData;
